import * as React from 'react';
import { TZUtils } from 'lib/tzutils';
import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';
import { parseDate } from 'common/services/routeParams';
import { DateRange } from 'portcall/daterangeselector/model';
import { parseDateRange, outboundDateRangeParams } from 'portcall/daterangeselector/routeParams';
import { VesselServiceProfile, VesselServiceProfileParams, VesselServiceProfileMode } from './model';
import { VesselServiceProfileView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export const VesselServiceProfileRoute = (
    model : (params : VesselServiceProfileParams) => VesselServiceProfile,
    appWrapper : AppWrapper,
    tzutils : TZUtils,
    request : Location
) : IRoute => {
    const m = model(inboundParams(request, tzutils));
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <VesselServiceProfileView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
};

function inboundParams(request : Location, tzutils : TZUtils) : VesselServiceProfileParams {
    const id = +(request.params['id'] || 0),
        mode = request.params['mode'],
        range = request.params['range'],
        from = request.params['from'],
        to = request.params['to'];

    return {
        id,
        mode: mode ? +mode : VesselServiceProfileMode.Particulars,
        range: range !== undefined ? parseDateRange(range) : DateRange.ThisMonth,
        from: from !== undefined ? parseDate(from, tzutils) : undefined,
        to: to !== undefined ? parseDate(to, tzutils) : undefined
    };
}

function outboundParams(request : Location, m : VesselServiceProfile) {
    const params = {} as LocationParams;
    params['id'] = m.Id + '';
    if (m.Mode() !== VesselServiceProfileMode.Particulars) params['mode'] = m.Mode() + '';
    outboundDateRangeParams(m.VesselPortCalls.DateRangeSelector, params, DateRange.ThisMonth, { range: 'range', from: 'from', to: 'to'});
    return new Location(request.name, params);
}


// WEBPACK FOOTER //
// ./apps/portcall/vesselserviceprofile/route.tsx